import script from "./PerformerProjectTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformerProjectTitle.vue?vue&type=script&setup=true&lang=js"

import "./PerformerProjectTitle.vue?vue&type=style&index=0&id=6a821570&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a821570"]])

export default __exports__